export default __webpack_public_path__ + "static/media/default.ebd1ad9e9f07924dcaa20b451a4a938e.svg";